import { styled } from "@mui/material/styles";
import * as React from "react";

interface IClassProps {
    center?: boolean;
    color: MprcColors;
}

interface IProps extends IClassProps {
    children?: React.ReactNode;
    message?: string | React.ReactNode;
    title?: string;
}

const StyledMessageBlock = styled
    (
        'div',
        { shouldForwardProp: (propName: string) => propName != "center" && propName != "variant" }
    )<IClassProps>(({ center, color, theme }) => ({
        textAlign: center ? "center" : "left",
        color: theme.palette[color].main
    }));

export const MprcMessageBlock: React.FC<IProps> = (props) => {
    const { message, title, children, color = "primary", center = true, ...classProps } = props;
    return <StyledMessageBlock {...classProps} color={color} center={center} title={title}>{message || children}</StyledMessageBlock>;
};
